module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-media', {
    staticStyle: {
      "height": "250px",
      "overflow": "hidden"
    },
    attrs: {
      "title": _vm.title,
      "subTitle": "粉丝：66.3万"
    }
  }, [_c('img', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "src": _vm.bigimg
    },
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "liebiao"
  }, [_c('ul', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, _vm._l((_vm.mylist), function(n, index) {
    return _c('li', {
      class: {
        gaol: _vm.gaoll == index
      },
      on: {
        "click": function($event) {
          _vm.setImg(n, index)
        }
      }
    }, [_c('p', [_c('b', [_vm._v(_vm._s(n.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(n.list))]), _vm._v(" "), _c('mu-checkbox', {
      staticClass: "demo-checkbox",
      attrs: {
        "uncheckIcon": "favorite_border",
        "nativeValue": n.hash,
        "disabled": _vm.isShow,
        "checkedIcon": "favorite"
      },
      model: {
        value: (_vm.getshou),
        callback: function($$v) {
          _vm.getshou = $$v
        },
        expression: "getshou"
      }
    })], 1), _vm._v(" "), _vm._m(0, true)])
  }))]), _vm._v(" "), _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.goback
    }
  }, [_c('img', {
    staticStyle: {
      "height": "30px",
      "margin-left": "20px",
      "margin-top": "20px",
      "padding": "0"
    },
    attrs: {
      "src": require("../../img/goback_1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('xstom', {
    attrs: {
      "list": _vm.bigimg,
      "get": _vm.title,
      "xiang": _vm.xiangxi,
      "outtime": _vm.outtime
    }
  }), _vm._v(" "), _c('xtop'), _vm._v(" "), _c('xplay'), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "top",
      "overlay": false,
      "popupClass": "demo-popup-top",
      "open": _vm.topPopup,
      "overlayColor": "#fff"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.collect) + "\n\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.news))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": require("../../img/jia.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-521669a6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZhenV_RT/xsong.vue
// module id = 259
// module chunks = 0